import LaboratoryMap from "@/views/laboratoryMap/laboratoryMap"

export default {
    path: '/LaboratoryMap',
    name: 'LaboratoryMap',
    component: LaboratoryMap,
  }


// WEBPACK FOOTER //
// ./src/router/laboratoryMap/index.js